"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _controlAutocomplete = require("@eig-builder/control-autocomplete");

var DataGridAutocomplete = function DataGridAutocomplete(props) {
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "mb-3"
  }, /*#__PURE__*/_react["default"].createElement(_controlAutocomplete.MultiSelectAutocomplete, props));
};

var _default = DataGridAutocomplete;
exports["default"] = _default;